import { formatCalendarDate } from '../../../Calendar.utils'

function getCalendarRelieveDayEmptyTargetHint({ nextFreeDay, t }) {
  if (!nextFreeDay) {
    return null
  }

  if (nextFreeDay.isFailed) {
    return { isFull: false, text: t('Calendar.LoadCheckFailedKey') }
  }

  return nextFreeDay.date
    ? null
    : { isFull: false, text: t('Calendar.RelieveDayNoFreeDayKey') }
}

function getCalendarRelieveDayTargetLoadAfter(dayLoad) {
  return {
    isFull: dayLoad.is_full_after ?? dayLoad.is_full,
    used: dayLoad.follow_up_count_after ?? dayLoad.follow_up_count,
  }
}

export function getCalendarRelieveDayTargetHint({
  day,
  locale,
  nextFreeDay,
  t,
  targetDate,
  targetLoad,
}) {
  if (!targetDate) {
    return getCalendarRelieveDayEmptyTargetHint({ nextFreeDay, t })
  }

  if (targetDate === day) {
    return { isFull: true, text: t('Calendar.MoveAnotherDayKey') }
  }

  if (targetLoad.isFailed) {
    return { isFull: false, text: t('Calendar.LoadCheckFailedKey') }
  }

  if (!targetLoad.dayLoad) {
    return null
  }

  const { isFull, used } = getCalendarRelieveDayTargetLoadAfter(
    targetLoad.dayLoad
  )

  return {
    isFull,
    text: t('Calendar.RelieveDayTargetLoadKey', {
      date: formatCalendarDate({ date: targetDate, locale }),
      limit: targetLoad.dayLoad.limit,
      used,
    }),
  }
}
